
// version.ts
export const VERSION = '0.3.11'; // Update this manually on each release

